var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nt-Tabs_NavItem"},[_c('button',{class:{
      'nt-Tabs_NavPill': _vm.type === 'pill',
      'nt-Tabs_NavLink': _vm.type === 'item',
      'nt-Tabs_NavLink-active': _vm.isActive,
    },attrs:{"type":"button"},on:{"click":function($event){return _vm.setActive(_vm.mutateUrl, _vm.scrollTo)}}},[_vm._t("default"),_vm._v(" "),(_vm.hasError)?_c('CircleAttention',{staticClass:"text-danger svg-12"}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }